import f from "../../../funcs";
import Events from "../../Events";


// TODO: удалить этот плагин, когда появится нормальный кэш

let StupidFixDocsLinkNextDate = Events.extend("StupidFixDocsLinkNextDate", {
    init(DOC_OPERATION_UNIT_LINK) {
        this.DOC_OPERATION_UNIT_LINK = DOC_OPERATION_UNIT_LINK;

        // UPDATE
        let update = DOC_OPERATION_UNIT_LINK.update_with();

        DOC_OPERATION_UNIT_LINK.update = function(id, changes, callback) {
            if ( !f.isFunction(callback) ) {
                callback = function() {};
            }

            update(id, changes, function(err, linkModel) {
                if ( !err ) {
                    this.fixNextDate(id, changes);
                }

                callback(err, linkModel);
            }.bind(this));
        }.bind(this);

        DOC_OPERATION_UNIT_LINK.update_with = function() {
            let args = [].slice.call(arguments);
            return function() {
                let args2 = [].slice.call(arguments);
                return DOC_OPERATION_UNIT_LINK.update.apply(DOC_OPERATION_UNIT_LINK, args.concat(args2));
            };
        };

    },

    fixNextDate(prevLinkId, changes) {
        let DOC_OPERATION_UNIT_LINK = this.DOC_OPERATION_UNIT_LINK;

        if ( !("DATE_END" in changes) ) {
            return;
        }

        let prevModel = DOC_OPERATION_UNIT_LINK.collection.get(prevLinkId);
        if ( !prevModel ) {
            return;
        }
        let prevDocId = prevModel.get("ID_DOC_OPERATION");
        let unitId = prevModel.get("ID_UNIT");

        DOC_OPERATION_UNIT_LINK.collection.each(function(nextModel) {
            if (
                (
                    nextModel.get("ID_PREV_DOC_OPERATION") == prevDocId
                        || nextModel.get("ID_DOC_OPERATION") == prevModel.get("ID_NEXT_DOC_OPERATION") && prevModel.get("ID_NEXT_DOC_OPERATION")
                )
                    && nextModel.get("ID_UNIT") == unitId
            ) {
                nextModel.set({
                    DATE_START: changes.DATE_END
                }, {
                    update: false
                });
                DOC_OPERATION_UNIT_LINK.sendEvent("__customRefreshInclude", nextModel);
            }
        });
    }
});

export default StupidFixDocsLinkNextDate;
